import actions from './actions'

export default function Invoice2sReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        // editing: null,
        saveSuccess: false,
      }

    case actions.LIST_WORKORDER_FOR_EXISTING_INVOICE2:
      return {
        ...state,
        editing: { workOrderID: 0 },
        result: action.result,
        deletedWorkOrderFromInvoice2: false,
        loading: false,
      }

    case actions.DELETE_WORKORDERS_FROM_INVOICE2_RECIEVED:
      console.log('Workorder DELETE_WORKORDERS_FROM_INVOICE2_RECIEVED')
      return {
        ...state,
        editing: { workOrderID: 0 },
        deletedWorkOrderFromInvoice2: true,
        loading: false,
      }

    default:
      return state
  }
}
